import { motion } from 'framer-motion';
import {
  MapPinIcon,
  UserGroupIcon,
  InformationCircleIcon,
} from '@heroicons/react/24/outline';
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/solid';
import { slugify, cleanNPSContent } from '@/lib/util';
import ClientOnly from '@/components/ClientOnly';

export default function EventContent({ event, className = '', parkfullname }) {
  // Function to remove emojis from text
  const removeEmojis = (text) => {
    if (!text) return text;

    // Comprehensive emoji removal regex
    // This covers most emoji ranges including:
    // - Basic emojis (U+1F600-U+1F64F)
    // - Supplemental symbols (U+1F900-U+1F9FF)
    // - Transport symbols (U+1F680-U+1F6FF)
    // - Miscellaneous symbols (U+2600-U+26FF)
    // - Dingbats (U+2700-U+27BF)
    // - And many more emoji ranges
    return text.replace(
      /[\u{1F600}-\u{1F64F}]|[\u{1F300}-\u{1F5FF}]|[\u{1F680}-\u{1F6FF}]|[\u{1F1E0}-\u{1F1FF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]|[\u{1F900}-\u{1F9FF}]|[\u{1F018}-\u{1F270}]|[\u{238C}-\u{2454}]|[\u{20D0}-\u{20FF}]|[\u{FE00}-\u{FE0F}]|[\u{FE20}-\u{FE2F}]|[\u{1F000}-\u{1F02F}]|[\u{1F0A0}-\u{1F0FF}]|[\u{1F100}-\u{1F64F}]|[\u{1F910}-\u{1F96B}]|[\u{1F980}-\u{1F9E0}]|[\u{1FAB0}-\u{1FABF}]|[\u{1FAC0}-\u{1FAFF}]|[\u{1FAD0}-\u{1FAFF}]|[\u{1FAE0}-\u{1FAFF}]|[\u{1FAF0}-\u{1FAFF}]/gu,
      ''
    );
  };

  // Safety check for event data
  if (!event) {
    return (
      <div className={`bg-white rounded p-8 ${className}`}>
        <p className="text-brown-200">Event information not available.</p>
      </div>
    );
  }

  const {
    description,
    location,
    meetingpoint,
    contactname,
    contactphonenumber,
    contactemailaddress,
  } = event;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 1.0 }}
      className={`bg-white rounded p-8 ${className}`}
    >
      {/* Description Section */}
      <div className="space-y-6">
        <div>
          <h3 className="text-lg font-semibold text-brown-200 mb-3">
            Description
          </h3>
          <ClientOnly>
            <div
              className="max-w-none text-brown-200 text-sm leading-loose"
              dangerouslySetInnerHTML={{
                __html: cleanNPSContent(removeEmojis(description)),
              }}
            />
          </ClientOnly>
        </div>
      </div>

      {/* About the Park Section */}
      {parkfullname && parkfullname.trim() && (
        <div className="my-8">
          <h3 className="text-lg font-semibold text-brown-200 mb-4">
            About the Park
          </h3>
          <div className="space-y-3">
            <p className="text-sm text-brown-200">
              Explore {parkfullname} and discover its natural wonders, scenic
              landscapes, and outdoor adventures.
            </p>
            <a
              href={`/park/${slugify(parkfullname)}`}
              className="inline-flex items-center gap-2 text-xs text-green-100 hover:text-green-100/80 font-bold transition-colors"
            >
              Learn more about {parkfullname}
              <ArrowTopRightOnSquareIcon className="w-3 h-3 -mt-1" />
            </a>
          </div>
        </div>
      )}

      {/* Contact Information */}
      {/* {(contactname || contactphonenumber || contactemailaddress) && (
                <div className="mt-8 pt-6">
                    <h3 className="text-lg font-semibold text-brown-200 mb-4 flex items-center gap-2">
                        <InformationCircleIcon className="w-6 h-6 text-green-100" />
                        Contact Information
                    </h3>
                    <div className="">
                        {contactname && (
                            <p className="text-sm text-brown-200 mb-2">
                                <span className="font-medium">Contact:</span> {contactname}
                            </p>
                        )}
                        {contactphonenumber && (
                            <p className="text-sm text-brown-200 mb-2">
                                <span className="font-medium">Phone:</span> 
                                <a href={`tel:${contactphonenumber}`} className="text-green-100 hover:text-green-100/80 ml-1">
                                    {contactphonenumber}
                                </a>
                            </p>
                        )}
                        {contactemailaddress && (
                            <p className="text-sm text-brown-200">
                                <span className="font-medium">Email:</span> 
                                <a href={`mailto:${contactemailaddress}`} className="text-green-100 hover:text-green-100/80 ml-1">
                                    {contactemailaddress}
                                </a>
                            </p>
                        )}
                    </div>
                </div>
            )} */}
    </motion.div>
  );
}
